// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2320a826","91":"edea67dc","819":"8a74e993","846":"8a336abf","864":"890f47f4","979":"1363c5b4"}[chunkId] + ".chunk.js";
};